import { render, staticRenderFns } from "./AigcVideoGenerator.vue?vue&type=template&id=04f2a43b&scoped=true&"
import script from "./AigcVideoGenerator.vue?vue&type=script&lang=js&"
export * from "./AigcVideoGenerator.vue?vue&type=script&lang=js&"
import style0 from "./AigcVideoGenerator.vue?vue&type=style&index=0&id=04f2a43b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2a43b",
  null
  
)

export default component.exports